import { InputField, isTabletPortraitDown } from '@enter/core';
import { mdiArrowLeft } from '@mdi/js';
import { Icon } from '@mdi/react';
import { Formik, FormikHelpers as FormikActions, FormikProps } from 'formik';
import _ from 'lodash';
import { inject, observer } from 'mobx-react';
import React from 'react';
import * as Yup from 'yup';
import { ISettingsPage } from '../shared';
import * as S from '../shared.styles';

const maxLength = 170;
const schema = Yup.object().shape({
    companyName: Yup.string().required('Company name is required'),
});

interface ICompany {
    companyName: string;
}

export const Company: React.FunctionComponent = inject('rootStore')(
    observer(
        (props: ISettingsPage): React.ReactElement => {
            const rootStore = _.get(props, 'rootStore');
            if (!rootStore) {
                return <></>;
            }

            const initial: ICompany = {
                companyName: _.get(props, 'rootStore.companyName', ''),
            };

            const handleSubmit = async (values: ICompany, { setSubmitting }: FormikActions<any>): Promise<void> => {
                const { companyName } = values;
                setSubmitting(true);
                await rootStore.changeCompanyName(companyName);
                setSubmitting(false);
                // NB: trigger re-initialization with changed values
                _.assign(initial, values);
            };
            const handleSave = (formik: FormikProps<ICompany>): (() => Promise<void>) => {
                // NB: avoid non-async formik.submitForm for now
                return async (): Promise<void> => {
                    await handleSubmit(formik.values, formik);
                };
            };

            return (
                <Formik
                    enableReinitialize={true}
                    initialValues={initial}
                    validationSchema={schema}
                    onSubmit={handleSubmit}>
                    {(formik: FormikProps<ICompany>): React.ReactElement => (
                        <S.SubCategoryItem>
                            {isTabletPortraitDown() && (
                                <S.ReturnLink to="/settings/overview">
                                    {(): React.ReactElement => <Icon path={mdiArrowLeft} size={1} />}
                                </S.ReturnLink>
                            )}
                            <S.SubCategoryH1>Tell us about your company</S.SubCategoryH1>
                            <S.SubCategoryForm>
                                <S.InputGroup>
                                    <S.Label>Company Name</S.Label>
                                    <S.FormField
                                        component={InputField}
                                        name="companyName"
                                        type="text"
                                        maxLength={maxLength}
                                        required={true}
                                    />
                                </S.InputGroup>
                            </S.SubCategoryForm>
                            <S.ButtonGroup
                                useNotify={true}
                                onCancel={formik.resetForm}
                                onSave={handleSave(formik)}
                                changed={formik.dirty}
                            />
                        </S.SubCategoryItem>
                    )}
                </Formik>
            );
        },
    ),
);
